var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCoffeeAndBakery = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Coffee-Cup--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Coffee Cup Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.94 19H1a1 1 0 0 0 0 2h21.94a1 1 0 0 0 0 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17.47a7.78 7.78 0 0 0 5 -2.33 0.51 0.51 0 0 1 0.36 -0.15H19A5 5 0 1 0 19 5h-1a0.5 0.5 0 0 1 -0.49 -0.5V4a1 1 0 0 0 -1 -1h-14a1 1 0 0 0 -1 1v5.51A8 8 0 0 0 10 17.47ZM19 7a3 3 0 1 1 0 6h-1.67a0.5 0.5 0 0 1 -0.46 -0.68 8.45 8.45 0 0 0 0.59 -3.09V7.51A0.5 0.5 0 0 1 18 7Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCoffeeAndBakery);
export default ForwardRef;